module.exports = __webpack_public_path__ + "img/4.40980c0b.jpg";